import { UnknownSchema } from '../../constants'
import { SchemaDefinition } from '../../models/SchemaDefinition'

import type { SchemaUnknownSpecific, TypedSchema } from '../../types'

export class SchemaUnknownDefinition extends SchemaDefinition {
  override defaultsMerge(
    value: any,
    schema: SchemaUnknownSpecific,
    initialize: boolean
  ) {
    if (initialize) {
      if (value === undefined) return schema.default
      return value
    }
    if (schema.required && value === undefined) {
      return schema.default
    }
    return value
  }

  override getIn(schema: SchemaUnknownSpecific, path: PropertyKey[]) {
    if (path.length === 0) return schema
    return UnknownSchema
  }

  override infer(target: any, schema: SchemaUnknownSpecific): TypedSchema {
    return { ...schema, ...super.inferShapeSchema(target) } as TypedSchema
  }

  override inferOnlySchema(schema: SchemaUnknownSpecific) {
    return schema
  }

  override inferTypeScript(): string {
    return `unknown`
  }

  override prune(target: any): any {
    return target
  }

  override transform(target: any, schema: SchemaUnknownSpecific) {
    if (target === null && schema.nullable) return target
    if (target === undefined) return schema.fallback
    return target
  }

  override validate(target: any, schema: SchemaUnknownSpecific): void {
    this.validateMetadata(target, schema)
  }
}
